import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import './index.less';
import './themes/default.less';

export default class ToggleSwitch extends MainComponent {
    static propTypes = {
        itemStyle: PropTypes.string,
        label: PropTypes.string,
        checked: PropTypes.bool,
        onChange: PropTypes.func,
        icon: PropTypes.object,
    };
    static defaultProps = {
        itemStyle: "",
        label: "",
        checked: false,
        onChange: null,
        icon: null
    };

    onChange() {
        if (this.props.onChange?.apply)
            this.props.onChange(!this.props.checked);
    }

    render() {
        const { itemStyle, label, checked, textBold, icon } = this.props;
        const cl = checked ? "checked" : "";

        return (
            <div ref={el => this.inputItem = el} className={`toggleSwitch flex gap8 ${itemStyle} ${cl}`} onClick={this.onChange.bind(this)}>
                <div className="slider rad16 transit04 hand">
                    <div className="sliderCirc radCirc transit04"></div>
                </div>
                {!!label && <div className="flex gap8">
                    <div className={`toggleSwitchLabel flex1 text ${textBold ? "p1SemiBold" : "p1"} hand`}>{this.tr(label)}</div>
                    {icon}
                </div>}
            </div>
        );
    }
}
